import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-2 lg:px-8" }
const _hoisted_2 = { class: "flex flex-col md:flex-row pt-4 items-center md:mb-4 gap-3" }
const _hoisted_3 = { class: "flex justify-self-end w-28" }
const _hoisted_4 = { class: "flex justify-self-end" }
const _hoisted_5 = { class: "flex justify-self-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WeekSwitcher = _resolveComponent("WeekSwitcher")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Star = _resolveComponent("Star")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_TimesheetTable = _resolveComponent("TimesheetTable")!
  const _component_TimesheetTableMobile = _resolveComponent("TimesheetTableMobile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "font-bold text-lg md:text-3xl" }, "Inserimento timesheet", -1)),
      _createVNode(_component_WeekSwitcher, {
        date: _ctx.date,
        "onUpdate:date": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
        class: "w-full max-w-[24rem]"
      }, null, 8, ["date"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Field, {
          modelValue: _ctx.filterDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterDate) = $event)),
          "label-visible": false,
          placeholder: "Anno",
          type: "number"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Field, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
          "label-visible": false,
          placeholder: "Cerca",
          type: "text"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Star, {
          class: "text-yellow-500 w-8 h-8",
          starred: _ctx.starred,
          onClick: _ctx.toggleStar
        }, null, 8, ["starred", "onClick"])
      ])
    ]),
    _withDirectives(_createVNode(_component_Alert, { class: "bg-next-orange" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.error), 1)
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.error]
    ]),
    _createVNode(_component_TimesheetTable, {
      onError: _cache[3] || (_cache[3] = ($event: any) => (_ctx.error = $event)),
      onRefreshRequired: _ctx.refresh,
      date: _ctx.date,
      "onUpdate:date": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.date) = $event)),
      records: _ctx.Records,
      loading: _ctx.loading,
      class: "hidden lg:block"
    }, null, 8, ["onRefreshRequired", "date", "records", "loading"]),
    _createVNode(_component_TimesheetTableMobile, {
      error: _ctx.error,
      "onUpdate:error": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.error) = $event)),
      date: _ctx.date,
      "onUpdate:date": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.date) = $event)),
      records: _ctx.Records,
      loading: _ctx.loading,
      onRefreshRequired: _ctx.refresh,
      class: "block lg:hidden"
    }, null, 8, ["error", "date", "records", "loading", "onRefreshRequired"])
  ]))
}